import React from 'react'
import { Skeleton } from '@mui/material'

const CardSkeleton = ({ height = '100%', className = 'ca-card-body' }) => (
  <div className={className}>
    <Skeleton variant="rounded" width="100%" height={height} animation="wave" sx={{ flex: 1 }} />
  </div>
)

export default CardSkeleton
